import { Component, OnInit } from '@angular/core';
import {ICellEditorAngularComp} from 'ag-grid-angular';
import {SharedService} from '../../../services/shared.service';
import {StorageService} from '../../../services/storage.service';

@Component({
  selector: 'app-cell-editor-brand',
  templateUrl: './cell-editor-brand.component.html',
  styleUrls: ['./cell-editor-brand.component.scss']
})
export class CellEditorBrandComponent implements ICellEditorAngularComp, OnInit {
  private params: any;
  public brands: any[] = [];
  public selected: any = {};

  constructor(
    private storageService: StorageService
  ) {
    const nullBrand = storageService.brands.filter(b => b.name === 'NULL');
    const othersBrands = storageService.brands.filter(b => b.name !== 'NULL');
    this.brands = nullBrand.concat(othersBrands);
  }

  ngOnInit(): void {
  }

  getValue(): any {
    // console.log('getValue BRAND', this.params);
    // console.log('this.params.data.brand', this.params.data.brand);
    // console.log('this.selected', this.selected);
    // this.params.data.brand = this.brands.find(brand => brand._id === this.selected._id);
    return this.selected;
    // if (this.defaultInitId === this.selected._id) {
    //   return false;
    // } else {
    //   return this.selected;
    // }
  }

  changeBrand(event: any): void {
    // console.log('changeBrand event !!!!🟠', event);
    this.selected = this.brands.find(brand => brand._id === event.value);
    // console.log(da);
    // console.log('changeBrand', this.selected);
    this.params.api.stopEditing();
  }

  agInit(params: any): void {
    this.params = params;
    this.selected = params.value;
    // console.log('CellEditorBrandComponent agInit', params);
  }
}
